import { Sparkles } from "lucide-react";

export const AiChatEmpty: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-4 py-8">
      <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center mb-3">
        <Sparkles className="h-5 w-5 text-gray-400" />
      </div>
      <h3 className="text-sm font-medium text-gray-700 mb-1">
        Wie kann ich Ihnen helfen?
      </h3>
    </div>
  );
};
